import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Search from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, DialogContentText, FormControl } from '@material-ui/core';
import AcertoCoparticipacaoService from '../../services/AcertoCoparticipacaoService';
import MUIDataTable from 'mui-datatables';
import { format } from 'date-fns';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import { inject, observer } from 'mobx-react';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  paperOrcamentoUniao: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    width: 750,
    minWidth: 750,
  },
  paperOrcamentoPlano: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    width: 750,
    minWidth: 750,
  },
  divPapers: {
    display: '-webkit-box'
  },
  dialogTitle: {
    display: 'inline',
  },
  typographyTituloPaper: {
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
    fontSize: 18
  },
  typographyDetalhePaper: {
    marginLeft: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    fontSize: 16
  },
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  paperFiltro: {
    height: 150,
    maxHeight: 150
  },
  fontTable: {
    fontSize: 12
  },
  typography: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    fontSize: 16,
    textAlign: 'center'
  },
  formControlAutoCompleteGuia: {
    margin: theme.spacing.unit,
    minWidth: 350,
  },
  calcPerc: {
    marginLeft: theme.spacing.unit * 7,
    display: 'inline-flex',
  },
  typographyInfo: {
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
});

@inject('aplicacaoStore')
@observer

class FormDialogProcedimentosDevolucao extends React.Component {
  acertosService = new AcertoCoparticipacaoService();
  state = {
    guias: [],
    procedimentos: [],
    rowsSelected: [],
    codGuiaSelected: 0,
    numDemonstrativoSelected: 0,
    seqPrestadorSelected: 0,
    valPagtoUniao: 0,
    valPagtoPlano: 0,
    valCopartUniao: 0,
    valCopartPlano: 0,
    fetching: false,
    info: '* As devoluções de coparticipação serão compensadas como Ajustes Financeiros (i.e. valores negativos) quando a devolução for processada.',
  }
  componentDidMount = async () => {
    await this.consultarGuias();
  }
  consultarGuias = async () => {
    let guias = await this.acertosService.consultarGuiasCarteiraPrestador(this.props.numMatricula, this.props.seqPrestador);
    this.setState({ guias: guias });
  }
  consultarProcedimentos = async (filtro) => {
    this.setState({fetching: true});
    let seqProcedimentosSelecionados = [];
    for (var i = 0; i < this.props.procsSelecionados.length; i++) {
      seqProcedimentosSelecionados.push(this.props.procsSelecionados[i][0]);
    }
    let procedimentos = await this.acertosService.consultarProcedimentosDevolucao(this.props.numMatricula, filtro.codGuia, seqProcedimentosSelecionados);
    this.setState({procedimentos: procedimentos, fetching: false});
  }
  handleClickBuscar = async () => {
    this.setState({procedimentos: []});
    const filtro = {
      codGuia: this.state.codGuiaSelected === undefined || this.state.codGuiaSelected === '' ? 0 : this.state.codGuiaSelected,
    };
    await this.consultarProcedimentos(filtro);
  }
  handleClose = () => {
    this.props.handleClose();
  }
  handleClickSave = async () => {
    let procedimentosSelecionados = [];
    for (var i = 0; i < this.state.rowsSelected.length; i++) {
      procedimentosSelecionados.push(this.state.procedimentos[this.state.rowsSelected[i]]);
    }
    this.props.handleSave(procedimentosSelecionados,
      this.state.valPagtoUniao,
      this.state.valCopartUniao,
      this.state.valPagtoPlano,
      this.state.valCopartPlano);
  }
  getSuggestionValueGuia = (suggestion, id) => {
    this.setState({
      codGuiaSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  render () {
    const options = {
      print: true,
      download: true,
      selectableRows: true,
      rowsSelected: this.state.rowsSelected,
      valPagtoUniao: this.state.valPagtoUniao,
      valCopartUniao: this.state.valCopartUniao,
      valPagtoPlano: this.state.valPagtoPlano,
      valCopartPlano: this.state.valCopartPlano,
      onRowsSelect: (rowsSelected, allRows) => {
        const selected = allRows.map(item => item.index);
        let valPagtoUniaoAux = 0;
        let valCopartUniaoAux = 0;
        let valPagtoPlanoAux = 0;
        let valCopartPlanoAux = 0;
        for (var i = 0; i < allRows.length; i++) {
          if (this.state.procedimentos[allRows[i].index][13] === 'Orçamento União') {
            valPagtoUniaoAux = valPagtoUniaoAux + Number(this.state.procedimentos[allRows[i].index][14]);
            valCopartUniaoAux = valCopartUniaoAux + Number(this.state.procedimentos[allRows[i].index][15]);
            this.setState({rowsSelected: selected, valPagtoUniao: valPagtoUniaoAux, valCopartUniao: valCopartUniaoAux});
          } else {
            valPagtoPlanoAux = valPagtoPlanoAux + Number(this.state.procedimentos[allRows[i].index][14]);
            valCopartPlanoAux = valCopartPlanoAux + Number(this.state.procedimentos[allRows[i].index][15]);
            this.setState({rowsSelected: selected, valPagtoPlano: valPagtoPlanoAux, valCopartPlano: valCopartPlanoAux});
          }
        }
      },
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>procedimento(s) selecionado(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'Cod. Cobrança',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Carteira',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqPrestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Prestador',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Guia',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Data do Procedimento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Data do Pagamento',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <Typography variant='overline'>{value !== null ? format(new Date(value), 'DD/MM/YYYY') : '-'}</Typography>;
          },
        }
      },
      {
        name: 'Origem do Pagamento',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Valor Cobrado do Prestador',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Devolvido ao Benef.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'cpf cnpj prestador',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'acoes',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];
    const { open, titulo, nome, numMatricula, classes } = this.props;
    const { procedimentos, fetching, info, guias } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='lg'
          fullWidth
          open={open}
          onClose={this.handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>{titulo}
            <div className={classes.divPapers}>
              <Paper className={classes.paperOrcamentoUniao} elevation={1}>
                <Typography className={classes.typographyTituloPaper}>
                  Totais da Origem de Pagamento: 00.509.968/0001-48 - Orçamento da União
                </Typography>
                <Typography className={classes.typographyDetalhePaper}>
                  Valor Total de Pagamento (Prestador): {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valPagtoUniao)}
                </Typography>
                <Typography className={classes.typographyDetalhePaper}>
                  Valor Total de Coparticipação (Benef.): {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valCopartUniao)}
                </Typography>
              </Paper>
              <Paper className={classes.paperOrcamentoPlano} elevation={1}>
                <Typography className={classes.typographyTituloPaper}>
                  Totais da Origem de Pagamento: 08.512.284/0001-07 - Orçamento do Plano
                </Typography>
                <Typography className={classes.typographyDetalhePaper}>
                  Valor Total de Pagamento (Prestador): {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valPagtoPlano)}
                </Typography>
                <Typography className={classes.typographyDetalhePaper}>
                  Valor Total de Coparticipação (Benef.): {new Intl.NumberFormat('pt-BR', {style: 'currency', fontWeight: 'bold', currency: 'BRL'}).format(this.state.valCopartPlano)}
                </Typography>
              </Paper>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {'Preencha os filtros para encontrar os procedimentos a serem devolvidos de '} {numMatricula} {' '} {nome}
            </DialogContentText>
            <Paper className={classes.paperFiltro} elevation={1}>
              <FormControl className={classes.formControlAutoCompleteGuia}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueGuia}
                  suggestions={guias}
                  maxSuggestions={3}
                  placeholder={'Digite a Guia...'} />
              </FormControl>
              <FormControl>
                <Button
                  variant='extendedFab'
                  disabled={this.state.codGuiaSelected === 0}
                  title='Buscar'
                  type='submit'
                  onClick={this.handleClickBuscar}
                  onTouchStart={this.handleClickBuscar}
                  className={classes.button}>
                  <Search className={classes.searchIcon} />
                  Buscar
                </Button>
              </FormControl>
              { procedimentos.length !== 0
                ? <Typography className={classes.typographyInfo}>{info}</Typography>
                : null
              }
            </Paper>
            {fetching ? <LinearProgressBlockScreen />
              : <Paper>
                <MUIDataTable
                  data={procedimentos}
                  columns={columns}
                  options={options}
                />
              </Paper>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              onClick={this.handleClickSave}
              disabled={this.state.rowsSelected.length === 0}
              color='primary'>
              Adicionar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogProcedimentosDevolucao);
